import { useTranslation } from 'react-i18next';

interface OnboardingSkipConfirmProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export function OnboardingSkipConfirm({ onCancel, onConfirm }: OnboardingSkipConfirmProps) {
  const { t } = useTranslation();

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="onboarding-skip-title"
      aria-describedby="onboarding-skip-description"
      className="flex w-[min(calc(100vw-24px),471px)] flex-col items-end gap-6 rounded-[12px] bg-white dark:bg-card-dark p-5"
    >
      <div className="flex w-full flex-col items-start gap-2">
        <h2
          id="onboarding-skip-title"
          className="font-sans text-[18px] font-semibold leading-7 text-[#242424] dark:text-textPrimary-dark"
        >
          {t('onboarding.leaveTour.title')}
        </h2>
        <p
          id="onboarding-skip-description"
          className="w-full font-sans text-sm font-medium leading-[22px] text-[#4F4F4F] dark:text-textSecondary-dark"
        >
          {t('onboarding.leaveTour.description')}
        </p>
      </div>
      <div className="flex w-full items-center justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          className="box-border flex h-11 flex-1 items-center justify-center rounded-lg border border-[#D0D5DD] dark:border-borderPrimary-dark bg-white dark:bg-card-dark px-3.5 py-2.5 font-sans text-sm font-semibold leading-5 text-[#344054] dark:text-textSecondary-dark shadow-[0px_1px_2px_rgba(16,24,40,0.05)] dark:shadow-black/20"
        >
          {t('onboarding.leaveTour.cancel')}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="box-border flex h-11 flex-1 items-center justify-center rounded-xl border border-[#F03D3D] dark:border-[#F03D3D] px-6 py-2.5 font-sans text-sm font-semibold leading-6 text-white dark:text-white [background:linear-gradient(180deg,rgba(255,255,255,0.2)_0%,rgba(255,255,255,0)_100%),#F03D3D] [box-shadow:0px_1px_2px_rgba(240,61,61,0.48)]"
        >
          {t('onboarding.leaveTour.confirm')}
        </button>
      </div>
    </div>
  );
}
